import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { API_BASE_URL } from './api-base';

@Injectable({ providedIn: 'root' })
export class ControlbordoService {
  private readonly baseUrl = `${API_BASE_URL}/controlbordo`;

  constructor(private http: HttpClient) {}

  getDashboard(tenantId: number, date?: string, userId?: number) {
    let params = new HttpParams().set('tenant_id', tenantId);
    if (date) {
      params = params.set('date', date);
    }
    if (userId) {
      params = params.set('user_id', userId);
    }
    return this.http.get(`${this.baseUrl}/dashboard`, { params });
  }

  getEntryDetails(tenantId: number, entryId: number) {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get(`${this.baseUrl}/entries/${entryId}`, { params });
  }

  createEntry(payload: any) {
    return this.http.post(`${this.baseUrl}/entries`, payload);
  }

  updateEntry(entryId: number, payload: any) {
    return this.http.put(`${this.baseUrl}/entries/${entryId}`, payload);
  }

  deleteEntry(entryId: number, tenantId: number, userId: number) {
    const params = new HttpParams()
      .set('tenant_id', tenantId)
      .set('user_id', userId);
    return this.http.delete(`${this.baseUrl}/entries/${entryId}`, { params });
  }

  uploadEntryAttachments(entryId: number, tenantId: number, uploadedBy: number, files: File[]) {
    const formData = new FormData();
    formData.append('tenant_id', String(tenantId));
    formData.append('uploaded_by', String(uploadedBy));
    files.forEach((file) => formData.append('files', file));
    return this.http.post(`${this.baseUrl}/entries/${entryId}/attachments`, formData);
  }
}
